import React, { Component, Dispatch } from 'react';
import './styles.scss';
import Dropdown from '../CommonComponents/Dropdown';
import {
	STAT_CARDS,
	ALL_ACTIONS,
	botID,
	ONGOING_STAT_CARDS,
	ANSWERED_HANDOFF_CARDS,
	PERFORMANCE_STAT_CARDS,
} from '../constants';
import { api, toTitleCase } from '../utils';
import DatePicker from '../CommonComponents/DatePicker';
import _moment, { Moment } from 'moment';
import { extendMoment } from 'moment-range';
// import originalMoment from 'moment';
// import { extendMoment } from 'moment-range';
import 'react-daterange-picker/dist/css/react-calendar.css';
import Modal from '../CommonComponents/Modal';
import ConversationList from './ConversationList';
import { _Conversation, _ViewConvo } from './models';

import TimeLineConversationList from './TimeLineConversationaList';

import ListIcon from '../assets/icons/list.svg';
import RankingList from './RankingList';
import BackBtnIcon from '../assets/icons/arrow_back.svg';
import BotPannel from '../CommonComponents/BotPannel';
import AnalyticsLoader from '../assets/icons/loader.svg';
import LoaderGIF from '../assets/icons/logout-loader.gif';
// import Loader from '../Loader';
// import { title } from 'process';
import Realtime from './Realtime';

type Props = {
	dispatch: Dispatch<{
		type: string;
		payload: boolean;
	}>;
	selectedBotDataFromAnalaytics: Function;
	toasterNotifier: Function;
	redirectionToLoginPage: Function;
	tenantId: number;
	// MakeAgentAvailability:Function;
	// callAvailabilty:Function;
};
type State = {
	endDate: Moment;
	startDate: Moment;
	RankingendDate: Moment;
	RankingstartDate: Moment;
	isAgentRankingLoading: boolean;
	isQueueRankingLoading: boolean;
	cardTitle: string | any;
	isdataLoading: boolean;
	isRealTimedataLoading: boolean;
	showLoader: boolean;
	selectedOne: string;
	selectedAgent: { name: string; id: number };
	selectedQueue: { name: string; id: number };
	agentList: { name: string; id: number; rank: string }[];
	cardList: {
		title: string;
		count: number;
		viewChats?: boolean;
		defnitions: string;
	}[];
	rankings: {
		topAgents: {
			name: string;
			count: number;
			percentage?: number;
			agentId?: string;
			chatHandledLaplace?: number;
			chatHandled: number;
			rank: number;
		}[];
		lowAgents: {
			name: string;
			count: number;
			percentage?: number;
			agentId?: string;
			chatHandledLaplace?: number;
			chatHandled: number;
			rank: number;
		}[];
		topQueue: {
			name: string;
			count: number;
			percentage?: number;
			agentId?: string;
			queueCountLaplace?: number;
			rank: number;
		}[];
		lowQueue: {
			name: string;
			count: number;
			percentage?: number;
			agentId?: string;
			queueCountLaplace?: number;
			rank: number;
		}[];
	};
	ongoingCardList: {
		title: string;
		count: number;
		defnitions: string;
	}[];
	performanceCardList: {
		title: string;
		count: number;
		defnitions: string;
	}[];
	answeredHandoffList: {
		title: string;
		count: number;
		viewChats?: boolean;
		defnitions: string;
	}[];
	isConversationModalOpen: boolean;
	isConevrsationTimelineOpen: boolean;
	conversationList: _Conversation[];
	queueFilter: { name: string; id: number; status: string }[];
	botFilter: {
		botName: string;
		botid: string;
		botIconUrl: string;
		baseURL: string;
	}[];
	conversationTitle: string;
	agentRankingList: { name: string; id: number; rank: number }[];
	selectedAgentRanking: { name: string; id: number };
	queueRankingList: { name: string; id: number; rank: number }[];
	selectedQueueRanking: { name: string; id: number };
	searchTerm: string;
	selectedBotid: string;
	selectedBoticonurl: string;
	selectedBotname: string;
	selectedBaseurl: string;
	agentRankingCompleteList: boolean;
	queueRankingCompleteList: boolean;
	isDropdownLoader: boolean;
	showDropdownLoader: boolean;
	agentRanking: {
		OverallRanking: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
			chatHandled: number;
		}[];
		AnsweredHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
			chatHandled: number;
		}[];
		ResolvedHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
			chatHandled: number;
		}[];
		UnresolvedHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
			chatHandled: number;
		}[];
		AbandonedHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
			chatHandled: number;
		}[];
		UserFeedback: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
			chatHandled: number;
		}[];
		AvgAgentResponseTime: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
			chatHandled: number;
		}[];
	};
	queueCompleteRankList: {
		OverallRanking: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
		NoofHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
		AnsweredHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
		ResolvedHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
		UnresolvedHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
		UnansweredHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
		AbandonedHandoffs: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
		userFeedback: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
		AvgUserWaitTimeinQueue: {
			name: string;
			count: number;
			percentage?: number;
			rank: number;
		}[];
	};
	viewConversationList: _ViewConvo[];
	showCollapsepannel: boolean;
	shwBotPannel: boolean;
	rankingSrc: string;
	selectedDate: any;
	shwLowRankedQueueData: boolean;
	shwLowRankedAgentData: boolean;
	ChannelSource: { name: string; id: number; deviceInfo?: string }[];
	selectedSource: { name: string; id: number; deviceInfo?: string };
	realTimeAgentList: {
		Name: string;
		EmailId: string;
		RoleName: string;
	}[];
	showAgentOnlineList: boolean;
	// ChannelSource: { name: string; id: number }[];
	// selectedSource: { name: string; id: number};
};

export default class Analytics extends Component<Props, State> {
	// @ts-ignore
	moment = extendMoment(_moment);

	constructor(props: Props) {
		super(props);
		this.state = this.setInitialState();
		this.selectCard = this.selectCard.bind(this);
		this.selectAgent = this.selectAgent.bind(this);
		this.selectSource = this.selectSource.bind(this);
		this.selectQueue = this.selectQueue.bind(this);
		this.viewchats = this.viewchats.bind(this);
		this.selectAgentRanking = this.selectAgentRanking.bind(this);
		this.selectQueueRanking = this.selectQueueRanking.bind(this);
		this.botconfig = this.botconfig.bind(this);
		this.fetchAgentRanking = this.fetchAgentRanking.bind(this);
		this.fetchQueueRanking = this.fetchQueueRanking.bind(this);
		this.setAgentRankingCompleteList =
			this.setAgentRankingCompleteList.bind(this);
		this.setQueueRankingCompleteList =
			this.setQueueRankingCompleteList.bind(this);
		this.dateSelection = this.dateSelection.bind(this);
		this.cleanDate = this.cleanDate.bind(this);
		this.getUTCData = this.getUTCData.bind(this);
		this.setviewAgentList = this.setviewAgentList.bind(this);
		this.getcurrentAgentsList = this.getcurrentAgentsList.bind(this);
		this.sortAgentList = this.sortAgentList.bind(this);
		//  this.getUserdownloadAnalytics=this.getUserdownloadAnalytics.bind(this);
	}

	setInitialState(): State {
		return {
			isAgentRankingLoading: false,
			cardTitle: '',
			isQueueRankingLoading: false,
			isdataLoading: false,
			isRealTimedataLoading: false,
			showLoader: false,
			showDropdownLoader: false,
			agentList: [],
			selectedOne: '',
			selectedAgent: {
				name: '',
				id: -1,
			},
			selectedQueue: {
				name: '',
				id: -1,
			},
			startDate: this.moment().clone(),
			endDate: this.moment().clone(),
			RankingendDate: this.moment().clone(),
			RankingstartDate: this.moment().clone(),
			cardList: STAT_CARDS,
			rankings: {
				topAgents: [],
				lowAgents: [],
				topQueue: [],
				lowQueue: [],
			},
			conversationList: [],
			isConversationModalOpen: false,
			isConevrsationTimelineOpen: false,
			queueFilter: [],
			botFilter: [],
			conversationTitle: '',
			selectedDate: '',
			agentRankingList: [
				// { name: 'Overall Performance', id: 0, rank: -1 },
				{ name: 'Answered Handoffs', id: 1, rank: -1 },
				{ name: 'Resolved Handoffs', id: 2, rank: -1 },
				{ name: 'Unresolved Handoffs', id: 3, rank: -1 },
				{ name: 'Abandoned Handoffs', id: 4, rank: -1 },
				{ name: 'User Feedback', id: 5, rank: -1 },
				{ name: 'Avg. Agent Response Time', id: 6, rank: -1 },
			],
			selectedAgentRanking: {
				name: 'Answered Handoffs',
				id: 1,
			},
			queueRankingList: [
				// { name: 'Overall Performance', id: 0, rank: -1 },
				{ name: 'No. of Handoffs', id: 1, rank: -1 },
				{ name: 'Answered Handoffs', id: 2, rank: -1 },
				{ name: 'Resolved Handoffs', id: 3, rank: -1 },
				{ name: 'Unresolved Handoffs', id: 4, rank: -1 },
				{ name: 'Abandoned Handoffs', id: 5, rank: -1 },
				{ name: 'Unanswered Handoffs', id: 6, rank: -1 },
				{ name: 'User Feedback', id: 7, rank: -1 },
				{ name: 'Avg. User Wait Time in Queue', id: 8, rank: -1 },
			],
			selectedQueueRanking: {
				name: 'No. of Handoffs',
				id: 1,
			},
			ongoingCardList: ONGOING_STAT_CARDS,
			answeredHandoffList: ANSWERED_HANDOFF_CARDS,
			performanceCardList: PERFORMANCE_STAT_CARDS,
			searchTerm: '',
			selectedBotid: '',
			selectedBoticonurl: '',
			selectedBotname: '',
			selectedBaseurl: '',
			agentRankingCompleteList: false,
			queueRankingCompleteList: false,
			agentRanking: {
				OverallRanking: [],
				AnsweredHandoffs: [],
				ResolvedHandoffs: [],
				UnresolvedHandoffs: [],
				AbandonedHandoffs: [],
				UserFeedback: [],
				AvgAgentResponseTime: [],
			},
			queueCompleteRankList: {
				OverallRanking: [],
				NoofHandoffs: [],
				AnsweredHandoffs: [],
				ResolvedHandoffs: [],
				UnresolvedHandoffs: [],
				UnansweredHandoffs: [],
				AbandonedHandoffs: [],
				userFeedback: [],
				AvgUserWaitTimeinQueue: [],
			},
			viewConversationList: [],
			showCollapsepannel: false,
			shwBotPannel: false,
			rankingSrc: '',
			shwLowRankedQueueData: false,
			shwLowRankedAgentData: false,
			isDropdownLoader: false,

			ChannelSource: [
				{
					name: 'All sources',
					id: 0,
					deviceInfo: '',
				},
				{
					name: 'Web (All devices)',
					id: 1,
					deviceInfo: '',
				},
				{
					name: 'Web (Tablet)',
					id: 2,
					deviceInfo: 'Tablet',
				},
				{
					name: 'Web (Mobile)',
					id: 3,
					deviceInfo: 'Mobile',
				},
				{
					name: 'Web (Desktop)',
					id: 4,
					deviceInfo: 'Desktop',
				},
				{
					name: 'WhatsApp',
					id: 4,
					deviceInfo: '',
				},
			],
			selectedSource: { name: 'All sources', id: 0, deviceInfo: '' },
			realTimeAgentList: [
				{
					Name: '',
					EmailId: '',
					RoleName: '',
				},
			],
			showAgentOnlineList: false,
		};
	}

	componentDidMount() {
		this.fetchBotFilter();
		// this.props.MakeAgentAvailability(false,true)
	}
	componentWillUnmount() {
		// this.props.callAvailabilty(true);
	}

	componentDidUpdate(_: Props, prevState: State) {
		if (prevState.selectedBotid !== this.state.selectedBotid) {
			const elem = document.querySelector('.analytics-data>div:last-child');
			if (elem) {
				elem.scrollTop = 0;
			}
		}
		if (
			prevState.selectedBotid !== this.state.selectedBotid
			// || prevState.selectedSource !== this.state.selectedSource
		) {
			if (
				this.state.selectedBotid !== '' &&
				this.state.selectedBotid !== undefined
			) {
				const promise = new Promise((resolve, reject) => {
					this.fetchAgentList(resolve);
				})
					.then((res) => {
						if (res === 'success') {
							this.fetchQueueList();
						}
					})
					.then(() => {
						this.fetchDetails();
						this.fetchAgentRanking();
						this.fetchQueueRanking();
					});
				this.setState({
					isConversationModalOpen: false,
				});
			}
		}
		if (
			(prevState.startDate !== this.state.startDate &&
				this.state.rankingSrc !== 'agent' &&
				this.state.rankingSrc !== 'queue') ||
			(prevState.endDate !== this.state.endDate &&
				this.state.rankingSrc !== 'agent' &&
				this.state.rankingSrc !== 'queue') ||
			prevState.selectedAgent !== this.state.selectedAgent ||
			prevState.selectedQueue !== this.state.selectedQueue ||
			prevState.selectedSource !== this.state.selectedSource
		) {
			this.fetchDetails('newDetails');
		}
		if (prevState.selectedAgentRanking !== this.state.selectedAgentRanking) {
			this.fetchAgentRanking();
		}
		if (prevState.selectedQueueRanking !== this.state.selectedQueueRanking) {
			this.fetchQueueRanking();
		}
	}
	fetchQueueList() {
		api(
			`listOfQueues?botId=${encodeURIComponent(
				this.state.selectedBotid
			)}&tenantId=${
				this.props.tenantId
			}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
		).then((response) => {
			if (response !== '') {
				this.setState({
					queueFilter: response.JsonResp.map((queuedata: any) => ({
						name: queuedata.queueName,
						id: queuedata.queueId,
						status: queuedata.status,
					})),
				});
			}
		});
	}
	fetchAgentList(resolve: Function) {
		api(
			`GetAgents?type=all&offset=1&limit=10&botId=${encodeURIComponent(
				this.state.selectedBotid
			)}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
		).then((response) => {
			this.setState(
				{
					agentList: response.agents.map((agent: any) => ({
						name: agent.userName,
						id: agent.AgentId,
						// rank: agent.rank,
					})),
				},
				() => {
					resolve('success');
				}
			);
		});
	}
	fetchBotFilter() {
		let agentId = sessionStorage.getItem('agentId');

		api(`listOfBots`, 'POST', {
			loggedInAgentId: agentId,
			tenantId: this.props.tenantId,
			screenName: 'Analytics',
			agentSessionID: sessionStorage.getItem('agentActiveSession'),
		}).then((response) => {
			if (response.error === 'Authentication Failed') {
				this.props.redirectionToLoginPage();
			} else {
				// if (response.redirectToLogin === true) {
				// 	this.props.redirectionToLoginPage();
				// } else {
				this.setState({
					botFilter: response.JsonResp.map((botdata: any) => ({
						botName: botdata.botName,
						botid: botdata.botId,
						botIconUrl: botdata.botIconURL,
						baseURL: botdata.envURL,
					})),
					selectedBoticonurl: response.JsonResp[0].botIconURL,
					selectedBotid: response.JsonResp[0].botId,
					selectedBotname: response.JsonResp[0].botName,
					selectedBaseurl: response.JsonResp[0].envURL,
				});
			}
		});
	}
	fetchAgentRanking() {
		let analyticsBotid = '';
		if (this.state.selectedBotid !== '') {
			analyticsBotid = this.state.selectedBotid;
		} else {
			analyticsBotid = botID;
		}
		let datachannel = '';
		if (this.state.selectedSource.name.indexOf('Web') > -1) {
			datachannel = 'webs';
		} else if (this.state.selectedSource.name === 'WhatsApp') {
			datachannel = 'whatsapp';
		} else {
			datachannel = this.state.selectedSource.name;
		}
		this.setState(
			{
				isAgentRankingLoading: true,
			},
			() => {
				api(
					//`queueAndAgentRankin?start=${this.state.startDate.format(
					`queueAndAgentRanking?start=${this.getUTCData().split('::')[0]}&end=${
						this.getUTCData().split('::')[1]
					}&agentId=${this.state.selectedAgent.id}&queueId=${
						this.state.selectedQueue.id
					}&channel=${datachannel}&botId=${analyticsBotid}&type=agent&factorName=${
						this.state.selectedAgentRanking.name
					}&timezoneOffset=${new Date().getTimezoneOffset()}
         &deviceInfo=${
						this.state.selectedSource.deviceInfo
					}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
				).then((res) => {
					this.setState({
						isAgentRankingLoading: false,
						// isDropdownLoader:true,
						// showDropdownLoader:false,
					});
					var agentRankings: any = [];
					if (this.state.selectedAgentRanking.name === 'Answered Handoffs') {
						if (
							JSON.parse(res.AgentRankingNoOfAnsweredHandoffs).lengthOfArray >=
							5
						) {
							this.setState({
								shwLowRankedAgentData: true,
							});
						}
						agentRankings = this.setAgentRanking(
							res.AgentRankingNoOfAnsweredHandoffs
						).filter((rankedData: any) =>
							JSON.parse(
								res.AgentRankingNoOfAnsweredHandoffs
							).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.agentId &&
									payloadData.agentId.toString()
							)
						);
					} else if (
						this.state.selectedAgentRanking.name === 'Resolved Handoffs'
					) {
						if (
							JSON.parse(res.AgentRankingResolvedHandoffs).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedAgentData: true,
							});
						}
						agentRankings = this.setAgentRanking(
							res.AgentRankingResolvedHandoffs
						).filter((rankedData: any) =>
							JSON.parse(res.AgentRankingResolvedHandoffs).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.agentId &&
									payloadData.agentId.toString()
							)
						);
					} else if (
						this.state.selectedAgentRanking.name === 'Unresolved Handoffs'
					) {
						if (
							JSON.parse(res.AgentRankingUnResolvedHandoffs).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedAgentData: true,
							});
						}
						agentRankings = this.setAgentRanking(
							res.AgentRankingUnResolvedHandoffs
						).filter((rankedData: any) =>
							JSON.parse(
								res.AgentRankingUnResolvedHandoffs
							).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.agentId &&
									payloadData.agentId.toString()
							)
						);
					} else if (
						this.state.selectedAgentRanking.name === 'Abandoned Handoffs'
					) {
						if (
							JSON.parse(res.AgentRankingAbandonedHandoffs).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedAgentData: true,
							});
						}
						agentRankings = this.setAgentRanking(
							res.AgentRankingAbandonedHandoffs
						).filter((rankedData: any) =>
							JSON.parse(res.AgentRankingAbandonedHandoffs).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.agentId &&
									payloadData.agentId.toString()
							)
						);
					} else if (this.state.selectedAgentRanking.name === 'User Feedback') {
						if (JSON.parse(res.AgentRankingUserFeedback).lengthOfArray >= 5) {
							this.setState({
								shwLowRankedAgentData: true,
							});
						}
						agentRankings = this.setAgentRanking(
							res.AgentRankingUserFeedback
						).filter((rankedData: any) =>
							JSON.parse(res.AgentRankingUserFeedback).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.agentId &&
									payloadData.agentId.toString()
							)
						);
					} else if (
						this.state.selectedAgentRanking.name === 'Avg. Agent Response Time'
					) {
						if (
							JSON.parse(res.AgentRankingAverageResponseTime).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedAgentData: true,
							});
						}
						agentRankings = this.setAgentRanking(
							res.AgentRankingAverageResponseTime
						).filter((rankedData: any) =>
							JSON.parse(
								res.AgentRankingAverageResponseTime
							).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.agentId &&
									payloadData.agentId.toString()
							)
						);
					} else if (
						this.state.selectedAgentRanking.name === 'Overall Performance'
					) {
						if (JSON.parse(res.AgentRankingOverall).lengthOfArray >= 5) {
							this.setState({
								shwLowRankedAgentData: true,
							});
						}
						agentRankings = this.setAgentRanking(
							res.AgentRankingOverall
						).filter((rankedData: any) =>
							JSON.parse(res.AgentRankingOverall).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.agentId &&
									payloadData.agentId.toString()
							)
						);
					}
					agentRankings = agentRankings.filter(
						(agent: any) => agent.count !== -100
					);
					this.setState(
						(prevState) => ({
							rankings: {
								...prevState.rankings,
								topAgents:
									// this.state.selectedAgentRanking.name !== 'Overall Performance' &&
									// this.state.selectedAgentRanking.name !== 'Answered Handoffs' &&
									// this.state.selectedAgentRanking.name !== 'User Feedback' &&
									// this.state.selectedAgentRanking.name !== 'Resolved Handoffs'
									//   ? agentRankings &&
									//     agentRankings
									//       .sort((agent1, agent2) =>
									//         agent2.chatHandledLaplace && agent1.chatHandledLaplace
									//           ? agent1.chatHandledLaplace - agent2.chatHandledLaplace
									//           : agent1.count - agent2.count
									//       )
									//       .slice(0, 5)
									//   :
									this.state.selectedAgentRanking.name ===
									'Avg. Agent Response Time'
										? agentRankings &&
										  agentRankings
												.sort((agent1: any, agent2: any) =>
													agent2.chatHandled && agent1.chatHandled
														? agent1.chatHandled - agent2.chatHandled
														: agent1.count - agent2.count
												)
												.slice(0, 5)
										: agentRankings &&
										  agentRankings
												.sort(
													(agent1: any, agent2: any) =>
														// agent2.chatHandledLaplace && agent1.chatHandledLaplace
														//   ? agent2.chatHandledLaplace - agent1.chatHandledLaplace
														// :
														agent2.count - agent1.count
												)
												.slice(0, 5),
								lowAgents:
									// this.state.selectedAgentRanking.name !== 'Overall Performance' &&
									// this.state.selectedAgentRanking.name !== 'Answered Handoffs' &&
									// this.state.selectedAgentRanking.name !== 'User Feedback' &&
									// this.state.selectedAgentRanking.name !== 'Resolved Handoffs'
									//   ? agentRankings &&
									//     agentRankings
									//       .sort((agent1, agent2) =>
									//         agent1.chatHandledLaplace && agent2.chatHandledLaplace
									//           ? agent2.chatHandledLaplace - agent1.chatHandledLaplace
									//           : agent2.count - agent1.count
									//       )
									//       .slice(0, 5)
									//   :
									// this.state.selectedAgentRanking.name === 'Avg. Agent Response Time'
									//   ? agentRankings &&
									//     agentRankings
									//       .sort((agent1:any, agent2:any) =>{
									//         if(agent2.chatHandled && agent1.chatHandled  ) {
									//           return agent1.chatHandled - agent2.chatHandled;
									//         } else {
									//           return agent2.chatHandled - agent1.chatHandled;
									//         }
									//       }
									//       )
									//       .slice(0, 5)
									//   :
									agentRankings &&
									agentRankings
										.sort(
											(agent1: any, agent2: any) =>
												// agent2.chatHandledLaplace && agent1.chatHandledLaplace
												//   ? agent1.chatHandledLaplace - agent2.chatHandledLaplace
												// :
												agent1.count - agent2.count
										)
										.slice(0, 5),
								topQueue: [...prevState.rankings.topQueue],
								lowQueue: [...prevState.rankings.topQueue],
							},
						})
						// () => {
						//   resolve && resolve('Success');
						// }
					);
				});
			}
		);
	}
	fetchQueueRanking() {
		let analyticsBotid = '';
		let datachannel = '';
		if (this.state.selectedSource.name.indexOf('Web') > -1) {
			datachannel = 'webs';
		} else if (this.state.selectedSource.name === 'WhatsApp') {
			datachannel = 'whatsapp';
		} else {
			datachannel = this.state.selectedSource.name;
		}
		// this.state.selectedSource.name
		if (this.state.selectedBotid !== '') {
			analyticsBotid = this.state.selectedBotid;
		} else {
			analyticsBotid = botID;
		}
		this.setState(
			{
				isQueueRankingLoading: true,
			},
			() => {
				api(
					`queueAndAgentRanking?start=${this.getUTCData().split('::')[0]}&end=${
						this.getUTCData().split('::')[1]
					}&agentId=${this.state.selectedAgent.id}&queueId=${
						this.state.selectedQueue.id
					}&channel=${datachannel}&deviceInfo=${
						this.state.selectedSource.deviceInfo
					}&botId=${encodeURIComponent(analyticsBotid)}&type=queue&factorName=${
						this.state.selectedQueueRanking.name
					}&timezoneOffset=${new Date().getTimezoneOffset()}&agentSessionID=${sessionStorage.getItem(
						'agentActiveSession'
					)}`
				).then((res) => {
					this.setState({
						isQueueRankingLoading: false,
					});
					var queueRankings: any = [];
					if (this.state.selectedQueueRanking.name === 'No. of Handoffs') {
						if (JSON.parse(res.QueueRankingNoOfHandoffs).lengthOfArray >= 5) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingNoOfHandoffs
						).filter((rankedData: any) =>
							JSON.parse(res.QueueRankingNoOfHandoffs).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.queueId.toString()
							)
						);
					} else if (
						this.state.selectedQueueRanking.name === 'Answered Handoffs'
					) {
						if (
							JSON.parse(res.QueueRankingNoOfAnsweredHandoffs).lengthOfArray >=
							5
						) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingNoOfAnsweredHandoffs
						).filter((rankedData: any) =>
							JSON.parse(
								res.QueueRankingNoOfAnsweredHandoffs
							).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.queueId.toString()
							)
						);
					} else if (
						this.state.selectedQueueRanking.name === 'Resolved Handoffs'
					) {
						if (
							JSON.parse(res.QueueRankingResolvedHandoffs).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingResolvedHandoffs
						).filter((rankedData: any) =>
							JSON.parse(res.QueueRankingResolvedHandoffs).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.queueId.toString()
							)
						);
					} else if (
						this.state.selectedQueueRanking.name === 'Unresolved Handoffs'
					) {
						if (
							JSON.parse(res.QueueRankingUnResolvedHandoffs).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingUnResolvedHandoffs
						).filter((rankedData: any) =>
							JSON.parse(
								res.QueueRankingUnResolvedHandoffs
							).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.queueId.toString()
							)
						);
					} else if (
						this.state.selectedQueueRanking.name === 'Abandoned Handoffs'
					) {
						if (
							JSON.parse(res.QueueRankingAbandonedHandoffs).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingAbandonedHandoffs
						).filter((rankedData: any) =>
							JSON.parse(res.QueueRankingAbandonedHandoffs).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.queueId.toString()
							)
						);
					} else if (
						this.state.selectedQueueRanking.name === 'Unanswered Handoffs'
					) {
						if (
							JSON.parse(res.QueueRankingUnansweredHandoffs).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingUnansweredHandoffs
						).filter((rankedData: any) =>
							JSON.parse(
								res.QueueRankingUnansweredHandoffs
							).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.queueId.toString()
							)
						);
					} else if (this.state.selectedQueueRanking.name === 'User Feedback') {
						if (JSON.parse(res.QueueRankingUserFeedback).lengthOfArray >= 5) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingUserFeedback
						).filter((rankedData: any) =>
							JSON.parse(res.QueueRankingUserFeedback).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.queueId.toString()
							)
						);
					} else if (
						this.state.selectedQueueRanking.name ===
						'Avg. User Wait Time in Queue'
					) {
						if (
							JSON.parse(res.QueueRankingAverageWaitingTime).lengthOfArray >= 5
						) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingAverageWaitingTime
						).filter((rankedData: any) =>
							JSON.parse(
								res.QueueRankingAverageWaitingTime
							).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId === payloadData.queueId.toString()
							)
						);
					} else if (
						this.state.selectedQueueRanking.name === 'Overall Performance'
					) {
						if (JSON.parse(res.QueueRankingOverall).lengthOfArray >= 5) {
							this.setState({
								shwLowRankedQueueData: true,
							});
						}
						queueRankings = this.setQueueRanking(
							res.QueueRankingOverall
						).filter((rankedData: any) =>
							JSON.parse(res.QueueRankingOverall).JsonStringResp.some(
								(payloadData: any) =>
									rankedData.agentId == payloadData.queueId.toString()
							)
						);
					}
					queueRankings = queueRankings.filter(
						(queue: any) => queue.count !== -100
					);
					this.setState(
						(prevState) => ({
							rankings: {
								...prevState.rankings,
								topAgents: [...prevState.rankings.topAgents],
								lowAgents: [...prevState.rankings.lowAgents],
								topQueue:
									// this.state.selectedQueueRanking.name !== 'No. of Handoffs' &&
									// this.state.selectedQueueRanking.name !== 'Overall Performance' &&
									// this.state.selectedQueueRanking.name !== 'User Feedback' &&
									// this.state.selectedQueueRanking.name !== 'Answered Handoffs' &&
									// this.state.selectedQueueRanking.name !== 'Resolved Handoffs'
									//   ? queueRankings &&
									//     queueRankings
									//       .sort((agent1, agent2) =>
									//         agent2.queueCountLaplace && agent1.queueCountLaplace
									//           ? agent1.queueCountLaplace - agent2.queueCountLaplace
									//           : agent1.count - agent2.count
									//       )
									//       .slice(0, 5)
									//   :
									this.state.selectedQueueRanking.name ===
									'Avg. User Wait Time in Queue'
										? queueRankings &&
										  queueRankings
												.sort(
													(agent1: any, agent2: any) =>
														agent1.count - agent2.count
												)
												.slice(0, 5)
										: queueRankings &&
										  queueRankings
												.sort(
													(queue1: any, queue2: any) =>
														queue2.count - queue1.count
												)
												.slice(0, 5),
								lowQueue:
									// this.state.selectedQueueRanking.name !== 'No. of Handoffs' &&
									// this.state.selectedQueueRanking.name !== 'Overall Performance' &&
									// this.state.selectedQueueRanking.name !== 'User Feedback' &&
									// this.state.selectedQueueRanking.name !== 'Answered Handoffs' &&
									// this.state.selectedQueueRanking.name !== 'Resolved Handoffs'
									//   ? queueRankings &&
									//     queueRankings
									//       .sort((agent1, agent2) =>
									//         agent2.queueCountLaplace && agent1.queueCountLaplace
									//           ? agent2.queueCountLaplace - agent1.queueCountLaplace
									//           : agent2.count - agent1.count
									//       )
									//       .slice(0, 5)
									//   :
									// this.state.selectedQueueRanking.name === 'Avg. User Wait Time in Queue'
									//   ? queueRankings &&
									//     queueRankings
									//       .sort((agent1:any, agent2:any) =>
									//            agent1.count - agent2.count
									//       )
									//       .slice(0, 5)
									//   :
									queueRankings &&
									queueRankings
										.sort(
											(queue1: any, queue2: any) => queue1.count - queue2.count
										)
										.slice(0, 5),
							},
						})
						// ()=>{

						//     resolve && resolve('Success');

						// }
					);
				});
			}
		);
	}

	setAgentRankingCompleteList(
		val: string,
		selectedAgent?: { name: string; id: number }
	) {
		//   console.log(selectedAgent ? selectedAgent.name : 'hi')
		let datachannel = '';
		if (this.state.selectedSource.name.indexOf('Web') > -1) {
			datachannel = 'webs';
		} else if (this.state.selectedSource.name === 'WhatsApp') {
			datachannel = 'whatsapp';
		} else {
			datachannel = this.state.selectedSource.name;
		}
		let analyticsBotid = '';
		if (this.state.selectedBotid !== '') {
			analyticsBotid = this.state.selectedBotid;
		} else {
			analyticsBotid = botID;
		}
		this.setState(
			{
				isAgentRankingLoading: true,
			},
			() => {
				api(
					`queueAndAgentRanking?start=${this.getUTCData().split('::')[0]}&end=${
						this.getUTCData().split('::')[1]
					}&agentId=${this.state.selectedAgent.id}&queueId=${
						this.state.selectedQueue.id
					}&channel=${datachannel}&deviceInfo=${
						this.state.selectedSource.deviceInfo
					}&botId=${encodeURIComponent(
						analyticsBotid
					)}&type=agent&factorName=${val}&timezoneOffset=${new Date().getTimezoneOffset()}&agentSessionID=${sessionStorage.getItem(
						'agentActiveSession'
					)}`
				).then((res) => {
					this.setState(
						(prevState) => ({
							isAgentRankingLoading: false,
							agentRanking: {
								...prevState.agentRanking,
								AnsweredHandoffs: this.setAgentRanking(
									res.AgentRankingNoOfAnsweredHandoffs
								),
								ResolvedHandoffs: this.setAgentRanking(
									res.AgentRankingResolvedHandoffs
								),
								UnresolvedHandoffs: this.setAgentRanking(
									res.AgentRankingUnResolvedHandoffs
								),
								AbandonedHandoffs: this.setAgentRanking(
									res.AgentRankingAbandonedHandoffs
								),
								UserFeedback: this.setAgentRanking(
									res.AgentRankingUserFeedback
								),
								AvgAgentResponseTime: this.setAgentRanking(
									res.AgentRankingAverageResponseTime
								),
								OverallRanking: this.setAgentRanking(res.AgentRankingOverall),
							},
							selectedAgentRanking: selectedAgent
								? { name: selectedAgent.name, id: selectedAgent.id }
								: prevState.selectedAgentRanking,
						}),
						() => {
							// console.log(selectedAgent ? selectedAgent.name : 'hi')
						}
					);
				});
			}
		);
	}
	setQueueRankingCompleteList(
		val: string,
		selectedQueue?: { name: string; id: number }
	) {
		let analyticsBotid = '';
		let datachannel = '';
		if (this.state.selectedSource.name.indexOf('Web') > -1) {
			datachannel = 'webs';
		} else if (this.state.selectedSource.name === 'WhatsApp') {
			datachannel = 'whatsapp';
		} else {
			datachannel = this.state.selectedSource.name;
		}
		// this.state.selectedSource.name
		if (this.state.selectedBotid !== '') {
			analyticsBotid = this.state.selectedBotid;
		} else {
			analyticsBotid = botID;
		}
		this.setState(
			{
				isQueueRankingLoading: true,
			},
			() => {
				api(
					`queueAndAgentRanking?start=${this.getUTCData().split('::')[0]}&end=${
						this.getUTCData().split('::')[1]
					}&agentId=${this.state.selectedAgent.id}&queueId=${
						this.state.selectedQueue.id
					}&channel=${datachannel}&deviceInfo=${
						this.state.selectedSource.deviceInfo
					}&botId=${analyticsBotid}&type=queue&factorName=${val}&timezoneOffset=${new Date().getTimezoneOffset()}&agentSessionID=${sessionStorage.getItem(
						'agentActiveSession'
					)}`
				).then((res) => {
					this.setState((prevState) => ({
						isQueueRankingLoading: false,
						queueCompleteRankList: {
							...prevState.queueCompleteRankList,
							NoofHandoffs: this.setQueueRanking(res.QueueRankingNoOfHandoffs),
							AnsweredHandoffs: this.setQueueRanking(
								res.QueueRankingNoOfAnsweredHandoffs
							),
							ResolvedHandoffs: this.setQueueRanking(
								res.QueueRankingResolvedHandoffs
							),
							UnresolvedHandoffs: this.setQueueRanking(
								res.QueueRankingUnResolvedHandoffs
							),
							UnansweredHandoffs: this.setQueueRanking(
								res.QueueRankingUnansweredHandoffs
							),
							AbandonedHandoffs: this.setQueueRanking(
								res.QueueRankingAbandonedHandoffs
							),
							userFeedback: this.setQueueRanking(res.QueueRankingUserFeedback),
							AvgUserWaitTimeinQueue: this.setQueueRanking(
								res.QueueRankingAverageWaitingTime
							),
							OverallRanking: this.setQueueRanking(res.QueueRankingOverall),
						},
						selectedQueueRanking: selectedQueue
							? { name: selectedQueue.name, id: selectedQueue.id }
							: prevState.selectedQueueRanking,
					}));
				});
			}
		);
	}
	cleanDate(date: Moment, toLocal?: any) {
		if (!toLocal) {
			return this.moment.utc(date).format('YYYY-MM-DD HH:mm:ss');
		}

		var utcMoment = this.moment.utc(date);
		var utcDate = new Date(utcMoment.format());

		return (
			utcDate.getFullYear() +
			'-' +
			(utcDate.getMonth() + 1) +
			'-' +
			utcDate.getDate() +
			' ' +
			utcDate.getHours() +
			':' +
			utcDate.getMinutes() +
			':' +
			utcDate.getSeconds()
		);
	}
	getUTCData() {
		var today = new Date();
		var startTime, endTime, todayStartTime, todayEndTime;
		var yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
		// console.log(this.state.startDate.format('YYYY-MM-DD'),this.moment(today).format('YYYY-MM-DD'))
		// if(this.state.startDate.format('YYYY-MM-DD')===this.moment(today).format('YYYY-MM-DD')){
		if (this.state.selectedDate === 'Today') {
			todayStartTime =
				today.getFullYear() +
				'-' +
				(today.getMonth() + 1) +
				'-' +
				today.getDate() +
				' 00:00:00';
			todayEndTime =
				today.getFullYear() +
				'-' +
				(today.getMonth() + 1) +
				'-' +
				today.getDate() +
				' 23:59:59';
			startTime = this.cleanDate(
				this.moment(todayStartTime, 'YYYY-MM-DD HH:mm:ss')
			);
			endTime = this.cleanDate(
				this.moment(todayEndTime, 'YYYY-MM-DD HH:mm:ss')
			);
		}

		// else if(this.state.endDate.format('YYYY-MM-DD')===this.moment(yesterday).format('YYYY-MM-DD')){
		else if (this.state.selectedDate === 'Yesterday') {
			// console.log(this.state.startDate.format('YYYY-MM-DD'),this.moment(yesterday).format('YYYY-MM-DD'))
			var yesterdayStartTime =
				yesterday.getFullYear() +
				'-' +
				(yesterday.getMonth() + 1) +
				'-' +
				yesterday.getDate() +
				' 00:00:00';
			// yesterday.setDate(yesterday.getDate() - 1);
			var yesterdayEndTime =
				yesterday.getFullYear() +
				'-' +
				(yesterday.getMonth() + 1) +
				'-' +
				yesterday.getDate() +
				' 23:59:59';
			startTime = this.cleanDate(
				this.moment(yesterdayStartTime, 'YYYY-MM-DD HH:mm:ss')
			);
			endTime = this.cleanDate(
				this.moment(yesterdayEndTime, 'YYYY-MM-DD HH:mm:ss')
			);
		} else {
			// var fullYear= this.state.startDate.format('YYYY-MM-DD')[0]
			// console.log(this.state.startDate,this.state.endDate)
			var newStartTime =
				this.state.startDate.format('YYYY-MM-DD') + ' 00:00:00';
			// yesterday.setDate(yesterday.getDate() - 1);
			var newEndTime = this.state.endDate.format('YYYY-MM-DD') + ' 23:59:59';

			startTime = this.cleanDate(
				this.moment(newStartTime, 'YYYY-MM-DD HH:mm:ss')
			);
			endTime = this.cleanDate(this.moment(newEndTime, 'YYYY-MM-DD HH:mm:ss'));
			// console.log(startTime,endTime)
		}
		return startTime + '::' + endTime;
	}

	fetchDetails(val?: string) {
		// console.log(val)
		this.props.dispatch({
			type: ALL_ACTIONS.UPDATE_LOADER_STATE,
			payload: true,
		});
		this.setviewAgentList(false);
		let analyticsBotid = '';
		if (this.state.selectedBotid !== '') {
			analyticsBotid = this.state.selectedBotid;
		} else {
			analyticsBotid = botID;
		}
		let datachannel = '';
		if (this.state.selectedSource.name.indexOf('Web') > -1) {
			datachannel = 'webs';
		} else if (this.state.selectedSource.name === 'WhatsApp') {
			datachannel = 'whatsapp';
		} else {
			datachannel = this.state.selectedSource.name;
		}
		// this.state.selectedSource.name
		let filterType = '';
		if (this.state.selectedAgent.id !== -1) {
			filterType = 'agent';
		}
		if (this.state.selectedQueue.id !== -1) {
			filterType = 'queue';
		}
		if (
			this.state.selectedQueue.id !== -1 &&
			this.state.selectedAgent.id !== -1
		) {
			filterType = 'both';
		}
		if (analyticsBotid !== '' && analyticsBotid !== undefined) {
			this.setState(
				{
					isdataLoading: true,
				},
				() => {
					if (val !== 'newDetails') {
						this.setState({
							isRealTimedataLoading: true,
						});
					}

					api(`getAnalyticsForWebAware`, 'POST', {
						start: this.getUTCData().split('::')[0],
						end: this.getUTCData().split('::')[1],
						queueId: this.state.selectedQueue.id,
						channel: datachannel,
						deviceInfo: this.state.selectedSource.deviceInfo,
						botId: encodeURIComponent(analyticsBotid),
						filterType: filterType,
						timezoneOffset: new Date().getTimezoneOffset(),
						agentId: this.state.selectedAgent.id,
						agentSessionID: sessionStorage.getItem('agentActiveSession'),
					})
						.then((response) => {
							if (response.error === 'Authentication Failed') {
								this.props.redirectionToLoginPage();
							} else {
								// if (response.redirectToLogin === true) {
								// 	this.props.redirectionToLoginPage();
								// } else {
								var agentRankings = this.setAgentRanking(
									response.AgentRankingOverall
								).filter((data) => data.count !== 0);
								var queueRankings = this.setQueueRanking(
									response.QueueRankingOverall
								).filter((data) => data.count !== 0);
								this.setState(
									(prevState) => ({
										isdataLoading: false,
										isRealTimedataLoading: false,
										cardList: prevState.cardList.map((card) => {
											switch (card.title) {
												case 'Total Conversations':
													return {
														...card,
														count: response.TotalConversation,
														defnitions: response.TotalConversationDef,
													};
												case 'Total Handoffs':
													return {
														...card,
														count: response.TotalHandoffs,
														defnitions: response.TotalHandoffsDef,
													};
												case 'Answered handoffs':
													return {
														...card,
														count: response.AnsweredHandoffs,
														defnitions: response.AnsweredHandoffsDef,
													};
												case 'Unanswered handoffs':
													return {
														...card,
														count: response.UnansweredHandoffs,
														defnitions: response.UnansweredHandoffsDef,
													};
												case 'Transfers':
													return {
														...card,
														count: response.Transfers,
														defnitions: response.TransfersDef,
													};
												case 'Releases':
													return {
														...card,
														count: response.Releases,
														defnitions: response.ReleasesDef,
													};

												case 'Transfers by agent':
													return {
														...card,
														count: response.TransfersByAgent,
														defnitions: response.TransfersByAgentDef,
													};
												case 'Releases by agent':
													return {
														...card,
														count: response.ReleasesByAgent,
														defnitions: response.ReleasesByAgentDef,
													};
												case 'Transfers from queue':
													return {
														...card,
														count: response.TransfersFromQueue,
														defnitions: response.TransfersFromQueueDef,
													};
												case 'Transfers to queue':
													return {
														...card,
														count: response.TransferToQueue,
														defnitions: response.TransferToQueueDef,
													};
												case 'Transfers by agent from queue':
													return {
														...card,
														count: response.TransfersByAgentFromQueue,
														defnitions: response.TransfersByAgentFromQueueDef,
													};
												case 'Released by agent from queue':
													return {
														...card,
														count: response.ReleasesByAgentFromQueue,
														defnitions: response.ReleasesByAgentFromQueueDef,
													};
												default:
													return card;
											}
										}),
										// rankings: {
										//   ...prevState.rankings,
										//   topAgents:
										//     agentRankings &&
										//     agentRankings
										//       .sort((agent1, agent2) => agent2.count - agent1.count)
										//       .slice(0, 5),
										//   lowAgents:
										//     agentRankings &&
										//     agentRankings
										//       .sort((agent1, agent2) => agent1.count - agent2.count)
										//       .slice(0, 5),
										//   topQueue:
										//     queueRankings &&
										//     queueRankings
										//       .sort((queue1, queue2) => queue2.count - queue1.count)
										//       .slice(0, 5),
										//   lowQueue:
										//     queueRankings &&
										//     queueRankings
										//       .sort((queue1, queue2) => queue1.count - queue2.count)
										//       .slice(0, 5),
										// },
										agentRanking: {
											...prevState.agentRanking,
											AnsweredHandoffs: [],
											ResolvedHandoffs: [],
											UnresolvedHandoffs: [],
											AbandonedHandoffs: [],
											UserFeedback: [],
											AvgAgentResponseTime: [],
											OverallRanking: [],
										},
										queueCompleteRankList: {
											...prevState.queueCompleteRankList,
											NoofHandoffs: [],
											ResolvedHandoffs: [],
											UnresolvedHandoffs: [],
											AbandonedHandoffs: [],
											UnansweredHandoffs: [],
											userFeedback: [],
											AvgUserWaitTimeinQueue: [],
											AnsweredHandoffs: [],
											OverallRanking: [],
										},
										conversationList: this.getAllConversations(
											response.AllConversatinList
										),
										ongoingCardList: prevState.ongoingCardList.map((card) => {
											switch (card.title) {
												case 'Total handed off chats':
													return {
														...card,
														count: response.TotalHandedOffChats,
														defnitions: response.TotalHandedOffChatsDef,
													};
												case 'Agents online':
													return {
														...card,
														count: response.AgentsOnline,
														defnitions: response.AgentsOnlineDef,
													};
												case 'Agent chats in progress':
													return {
														...card,
														count: response.AgentsChatsInProgress,
														defnitions: response.AgentsChatsInProgressDef,
													};
												case 'Chats in queue':
													return {
														...card,
														count: response.ChatsInQueue,
														defnitions: response.ChatsInQueueDef,
													};
												default:
													return card;
											}
										}),
										answeredHandoffList: prevState.answeredHandoffList.map(
											(card) => {
												switch (card.title) {
													case 'Resolved':
														return {
															...card,
															count: response.Resolved,
															defnitions: response.ResolvedDef,
														};
													case 'Unresolved':
														return {
															...card,
															count: response.Unresolved,
															defnitions: response.UnresolvedDef,
														};
													case 'Abandoned':
														return {
															...card,
															count: response.Abandoned,
															defnitions: response.AbandonedDef,
														};
													case 'No disposition':
														return {
															...card,
															count: response.NoDesposition,
															defnitions: response.NoDespositionDef,
														};
													default:
														return card;
												}
											}
										),
										performanceCardList: prevState.performanceCardList.map(
											(card) => {
												switch (card.title) {
													case 'User feedback':
														return {
															...card,
															count: response.UserFeedback,
															defnitions: response.UserFeedbackDef,
														};
													case 'Avg. user wait time in queue':
														return {
															...card,
															count: response.AvgUserWaitTimeInQueue,
															defnitions: response.AvgUserWaitTimeInQueueDef,
														};
													case 'Avg. agent response time':
														return {
															...card,
															count: response.AvgAgentResponseTime,
															defnitions: response.AvgAgentResponseTimeDef,
														};
													default:
														return card;
												}
											}
										),
									}),
									() => {
										// console.log("hi")
										// this.fetchAgentRanking();
										// this.fetchQueueRanking();
										// if(!this.state.isDropdownLoader || this.state.showDropdownLoader){
										//   this.fetchAgentRanking();
										//   this.fetchQueueRanking();
										// }
									}
								);
							}
						})
						.finally(() => {
							this.props.dispatch({
								type: ALL_ACTIONS.UPDATE_LOADER_STATE,
								payload: false,
							});
						});
				}
			);
		}
	}

	setAgentRanking(
		list:
			| string
			| {
					name: string;
					count: number;
					percentage?: number;
					agentId?: string;
					chatHandledLaplace?: number;
					rank: number;
					chatHandled: number;
			  }[]
	): {
		name: string;
		count: number;
		percentage?: number;
		agentId?: string;
		chatHandledLaplace?: number;
		rank: number;
		chatHandled: number;
	}[] {
		if (typeof list === 'string') {
			try {
				const ranking: {
					agentId: string;
					chatHandled: number;
					count: string;
					chatHandledLaplace: string;
					rank: number;
					queuePercentageCount: string;
				}[] = JSON.parse(list).JsonStringResp;
				// console.log(list);
				// console.log(ranking);
				let agentList = this.state.agentList.filter(
					(data) => data.name !== 'All Agents'
				);
				return agentList.map((agent) => {
					const found = ranking.find((rank) => {
						return rank.agentId == agent.id.toString() && rank;
					});
					return {
						name: agent.name,
						count: found
							? found.queuePercentageCount === '-'
								? -100
								: found.queuePercentageCount
								? +Math.round(parseFloat(found.queuePercentageCount) * 100) /
								  100
								: +found.count
							: -100,
						percentage: found && found.count ? +found.count : -100,
						agentId: agent.id.toString(),
						rank: (found && found.rank) || -1,
						chatHandledLaplace: found ? +found.chatHandledLaplace : -100,
						chatHandled: found && found.chatHandled ? found.chatHandled : 0,
					};
				});
			} catch (e) {
				console.error(e);
				return [];
			}
		} else {
			return [];
		}
	}

	setQueueRanking(
		list:
			| string
			| {
					name: string;
					count: number;
					queueId?: string;
					queueCountLaplace?: number;
					rank: number;
			  }[]
	): {
		name: string;
		count: number;
		queueId?: string;
		queueCountLaplace?: number;
		rank: number;
	}[] {
		if (typeof list === 'string') {
			try {
				const ranking: {
					queueName: string;
					queueCount: string;
					count: string;
					queueCountLaplace: number;
					queueId: string;
					queuePercentageCount: string;
					rank: number;
				}[] = JSON.parse(list).JsonStringResp;
				let queueList = this.state.queueFilter.filter(
					(data) => data.name !== 'All Queues'
				);
				return queueList.map((agent) => {
					const found = ranking.find(
						(rank) =>
							rank.queueId && rank.queueId.toString() === agent.id.toString()
					);
					return {
						name: toTitleCase(agent.name.replace('GS', '')),
						count: found
							? found.queuePercentageCount === '-'
								? -100
								: found.queuePercentageCount
								? +Math.round(parseFloat(found.queuePercentageCount) * 100) /
								  100
								: +found.queueCount
							: -100,
						percentage: found && found.count ? +found.count : -100,
						agentId: agent.id.toString(),
						rank: found ? found.rank : -1,
						queueCountLaplace: found ? +found.queueCountLaplace : -100,
					};
				});
			} catch (e) {
				console.error(e);
				return [];
			}
		} else {
			return [];
		}
	}

	getAllConversations(listStr: string): _Conversation[] {
		const list = listStr && JSON.parse(listStr);
		if (list && list.resp) {
			return list.resp.map((conv: any) => ({
				userName: conv.name || '-',
				agentName: conv.agentName || '-',
				transferHistory: (conv.conv_action || '-').split(','),
				queueName: (conv.queueName || 'loan')
					.replace(/GS/, '')
					.replace(/_M/, ''),
			}));
		} else {
			return [];
		}
	}

	selectAgent(index: number | undefined) {
		this.setState({
			selectedAgent:
				typeof index === 'number'
					? this.state.agentList[index]
					: { name: '', id: -1 },
		});
	}
	selectQueue(index: number | undefined) {
		// console.log(index)
		this.setState({
			selectedQueue:
				typeof index === 'number'
					? this.queueDataList[index]
					: { name: '', id: -1 },
		});
	}
	selectSource(index: number | undefined) {
		this.setState({
			selectedSource:
				typeof index === 'number'
					? this.state.ChannelSource[index]
					: { name: '', id: -1, deviceInfo: '' },
			// : { name: '', id: -1},
		});
	}
	selectAgentRanking(index: number | undefined) {
		this.setState({
			selectedAgentRanking:
				typeof index === 'number'
					? this.state.agentRankingList[index]
					: { name: '', id: -1 },
		});
	}
	selectQueueRanking(index: number | undefined) {
		this.setState({
			selectedQueueRanking:
				typeof index === 'number'
					? this.state.queueRankingList[index]
					: { name: '', id: -1 },
		});
	}
	selectCard(index: number | undefined) {
		this.setState({
			selectedOne:
				typeof index === 'number' ? this.state.cardList[index].title : '',
		});
	}
	viewchats(title?: string, agentId?: string, queueId?: string) {
		let analyticsBotid = '';
		if (this.state.selectedBotid !== '') {
			analyticsBotid = this.state.selectedBotid;
		} else {
			analyticsBotid = botID;
		}
		let datachannel = '';
		if (this.state.selectedSource.name.indexOf('Web') > -1) {
			datachannel = 'webs';
		} else if (this.state.selectedSource.name === 'WhatsApp') {
			datachannel = 'whatsapp';
		} else {
			datachannel = this.state.selectedSource.name;
		}
		this.setState(
			{
				showLoader: true,
				cardTitle: title,
				isConversationModalOpen: true,
			},
			() => {
				api(
					`getUserHistory?start=${this.getUTCData().split('::')[0]}&end=${
						this.getUTCData().split('::')[1]
					}&agentId=${
						agentId ? agentId : this.state.selectedAgent.id
					}&queueId=${
						queueId ? queueId : this.state.selectedQueue.id
					}&channel=${datachannel}&deviceInfo=${
						this.state.selectedSource.deviceInfo
					}&cardName=${title}&botId=${encodeURIComponent(
						analyticsBotid
					)}&timezoneOffset=${new Date().getTimezoneOffset()}&agentSessionID=${sessionStorage.getItem(
						'agentActiveSession'
					)}`
				).then((response) => {
					this.setState({
						showLoader: false,
						isConversationModalOpen: true,
						viewConversationList: this.getAllConversationsHistory(response),
					});
				});
			}
		);
	}

	getAllConversationsHistory(listStr: string): _ViewConvo[] {
		const list = listStr && JSON.parse(JSON.stringify(listStr));
		if (list && list.userHistory) {
			return list.userHistory.map((conv: any) => ({
				session_id: conv.sessionId || '-',
				userDetails: conv.userDetails || '-',
				language: conv.language || '-',
				handOffTime: conv.handoff_time || '-',
				actionHistory: conv.actionList || '-',
				rowid: conv.row || '-',
				status: conv.status || '-',
				agentComment: conv.agentComment || '-',
				userFeedback: conv.userFeedback || '-',
				comment: conv.userComment || '-',
				channel: conv.channel || '-',
				deviceInfo: conv.deviceInfo || '-',
				waitingTime: conv.waitingTime || '-',
				referer: conv.referer || '-',
			}));
		} else {
			return [];
		}
	}
	botconfig(selectedBotdata: any) {
		this.setState(
			{
				selectedBotid: selectedBotdata.botid || selectedBotdata.botId,
				selectedBoticonurl:
					selectedBotdata.botIconUrl || selectedBotdata.botIconURL,
				selectedBotname: selectedBotdata.botName,
			},
			() => {
				this.props.selectedBotDataFromAnalaytics(selectedBotdata);
			}
		);
	}
	agentRankingCompleteList() {
		// let promise = new Promise((resolve, reject) => {
		//   this.fetchAgentRanking(resolve);
		// });
		// promise.then((res) => {
		//   if (res === 'Success') {
		//     this.setState({
		//       agentRankingCompleteList: !this.state.agentRankingCompleteList,
		//     });
		//   }
		// });
		this.setState({
			agentRankingCompleteList: !this.state.agentRankingCompleteList,
		});
	}
	queueRankingCompleteList() {
		// let promise = new Promise((resolve, reject) => {
		//   this.fetchQueueRanking(resolve);
		// });
		// promise.then((res) =>{
		//   if(res === 'Success'){
		//     this.setState({
		//       queueRankingCompleteList: !this.state.queueRankingCompleteList,
		//     });
		//   }
		// })
		this.setState({
			queueRankingCompleteList: !this.state.queueRankingCompleteList,
		});
	}
	get cardList() {
		return this.state.selectedAgent.id !== -1 &&
			this.state.selectedQueue.id !== -1
			? this.state.cardList.filter(
					(card) =>
						card.title !== 'Transfers from queue' &&
						card.title !== 'Transfers to queue' &&
						card.title !== 'Transfers' &&
						card.title !== 'Releases' &&
						card.title !== 'Transfers by agent' &&
						card.title !== 'Releases by agent' &&
						card.title !== 'Unanswered handoffs' &&
						card.title !== 'Total Handoffs'
			  )
			: this.state.selectedAgent.id !== -1
			? this.state.cardList.filter(
					(card) =>
						card.title === 'Answered handoffs' ||
						card.title === 'Transfers by agent' ||
						card.title === 'Releases by agent'
			  )
			: this.state.selectedQueue.id !== -1
			? this.state.cardList.filter(
					(card) =>
						card.title !== 'Transfers by agent' &&
						card.title !== 'Releases by agent' &&
						card.title !== 'Transfers' &&
						card.title !== 'Released by agent from queue' &&
						card.title !== 'Transfers by agent from queue'
			  )
			: this.state.cardList.filter(
					(card) =>
						card.count !== undefined &&
						card.title !== 'Transfers by agent' &&
						card.title !== 'Releases by agent' &&
						card.title !== 'Transfers from queue' &&
						card.title !== 'Transfers to queue' &&
						card.title !== 'Transfers by agent from queue' &&
						card.title !== 'Released by agent from queue'
			  );
	}
	get ongoingCardList() {
		return this.state.ongoingCardList;
	}
	get answeredHandoffs() {
		return this.state.answeredHandoffList;
	}
	get performanceCardList() {
		return this.state.selectedAgent.id !== -1
			? this.state.performanceCardList.filter(
					(card) => card.title !== 'Avg. user wait time in queue'
			  )
			: this.state.performanceCardList;
	}
	get botfilterSearch() {
		const searchTerm = this.state.searchTerm.toLowerCase();

		return this.state.botFilter.filter(
			(botFilter) => botFilter.botName.toLowerCase().indexOf(searchTerm) >= 0
		);
	}
	convertSecondstoTime(secs: number) {
		let dateObj = new Date(secs * 1000);
		let minutes = dateObj.getUTCMinutes();
		let seconds = dateObj.getSeconds();

		let timeString =
			minutes.toString().padStart(2, '0') +
			' min ' +
			seconds.toString().padStart(2, '0') +
			' sec ';

		return timeString;
	}
	dateSelection(
		start: Moment,
		end: Moment,
		val: string,
		src: string,
		selected?: string
	) {
		// console.log(this.state.showDropdownLoader)
		this.setState(
			{
				startDate: start,
				endDate: end,
				rankingSrc: src,
				selectedDate: selected,
				// showDropdownLoader:true,
			},
			() => {
				if (src === 'agent') {
					this.setAgentRankingCompleteList(val);
				} else {
					this.setQueueRankingCompleteList(val);
				}
			}
		);
	}
	sortAgentList(users: any) {
		const sortedusers = users.sort(function (a: any, b: any) {
			var nameA = a.Name.toUpperCase(); // ignore upper and lowercase
			var nameB = b.Name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1; //nameA comes first
			}
			if (nameA > nameB) {
				return 1; // nameB comes first
			}
			return 0; // names must be equal
		});
		return sortedusers;
	}

	getcurrentAgentsList() {
		let analyticsBotid = '';
		if (this.state.selectedBotid !== '') {
			analyticsBotid = this.state.selectedBotid;
		}
		if (analyticsBotid === '') {
			return;
		}
		api(`getRealTimeAgentsList`, 'POST', {
			botId: encodeURIComponent(analyticsBotid),
			agentSessionID: sessionStorage.getItem('agentActiveSession'),
			tenantId: this.props.tenantId,
		}).then((response: any) => {
			if (response.ResData.error === 'Authentication Failed') {
				this.props.redirectionToLoginPage();
			} else {
				if (response.ResData) {
					// if (response.ResData.redirectToLogin === true) {
					// 	this.props.redirectionToLoginPage();
					// } else {
					if (response.ResType === 'Success') {
						var data = response.ResData.ResArray;
						this.setState({
							realTimeAgentList: this.sortAgentList(data),
						});
					}
					// }
				}
			}
		});
	}

	setviewAgentList = (bool: boolean) => {
		this.setState({
			showAgentOnlineList: bool,
		});
	};
	hideCollapsepannel() {
		this.setState({
			shwBotPannel: !this.state.shwBotPannel,
		});
	}
	get lowAgentData() {
		// return this.state.rankings.lowAgents.filter((data) => {
		//   this.state.rankings.topAgents.filter((agent) => {
		//     return agent.name !== data.name;
		//   });
		// });
		return this.state.rankings.lowAgents.filter(
			(val) => !this.state.rankings.topAgents.includes(val)
		);
	}
	get lowQueueData() {
		// return this.state.rankings.lowQueue.filter((data) => {
		//   this.state.rankings.topQueue.map((dataList) => {
		//     return dataList.name !== data.name;
		//   });
		// });
		return this.state.rankings.lowQueue.filter(
			(val) => !this.state.rankings.topQueue.includes(val)
		);
	}
	get queueDataList() {
		//console.log(this.state.queueFilter.filter((data)=> data.status !== 'deleted'))
		return this.state.queueFilter.filter((data) => {
			return data.status !== 'deleted';
			//return !data.status.includes('deleted');
		});
	}
	get topAgentData() {
		return this.state.rankings.topAgents.filter((data) => {
			return data.count !== 0;
		});
	}
	render() {
		if (sessionStorage.getItem('roleId') !== '2') {
			return (
				<div
					className={`${
						this.state.shwBotPannel
							? 'analytics-collapsed-wrapper'
							: 'analytics-wrapper'
					}`}>
					<BotPannel
						fetchbotData={this.botconfig}
						botHeader='Analyze'
						botFilterHeader='analytics'
						Collapsepannel={this.hideCollapsepannel.bind(this)}
						selectedBotId={this.state.selectedBotid}
						selectedBotName={this.state.selectedBotname}
						selectedBotIconUrl={this.state.selectedBoticonurl}
						source='Analytics'
						redirectionToLoginPage={this.props.redirectionToLoginPage}
						tenantId={this.props.tenantId}
						selectedBaseURL={this.state.selectedBaseurl}
					/>
					{this.state.agentRankingCompleteList ? (
						<RankingList
							onClose={() => {
								this.setState(
									{
										agentRankingCompleteList: false,
									},
									() => {
										this.fetchDetails();
										this.fetchAgentRanking();
										this.fetchQueueRanking();
									}
								);
							}}
							backBtnIcon={BackBtnIcon}
							setRankList={this.state.agentRanking}
							source='agent'
							selectedbotIcon={this.state.selectedBoticonurl}
							selectedbotName={this.state.selectedBotname}
							setRankingCompleteList={this.setAgentRankingCompleteList}
							startDate={this.state.startDate}
							endDate={this.state.endDate}
							utcstartDate={this.getUTCData().split('::')[0]}
							utcendDate={this.getUTCData().split('::')[1]}
							dateSelection={this.dateSelection}
							selectedFilter={this.state.selectedAgentRanking}
							botID={this.state.selectedBotid.trim() || botID}
							channelSource={this.state.selectedSource.name}
							deviceInfo={this.state.selectedSource.deviceInfo}
							downloadToaterNotify={this.props.toasterNotifier}
							isAgentRankingLoading={this.state.isAgentRankingLoading}
							isQueueRankingLoading={this.state.isQueueRankingLoading}
						/>
					) : this.state.queueRankingCompleteList ? (
						<RankingList
							onClose={() => {
								this.setState(
									{
										queueRankingCompleteList: false,
									},
									() => {
										this.fetchDetails();
										this.fetchAgentRanking();
										this.fetchQueueRanking();
									}
								);
							}}
							backBtnIcon={BackBtnIcon}
							setqueueRankList={this.state.queueCompleteRankList}
							source='queue'
							selectedbotIcon={this.state.selectedBoticonurl}
							selectedbotName={this.state.selectedBotname}
							setRankingCompleteList={this.setQueueRankingCompleteList}
							startDate={this.state.startDate}
							endDate={this.state.endDate}
							utcstartDate={this.getUTCData().split('::')[0]}
							utcendDate={this.getUTCData().split('::')[1]}
							dateSelection={this.dateSelection}
							selectedFilter={this.state.selectedQueueRanking}
							botID={this.state.selectedBotid.trim() || botID}
							channelSource={this.state.selectedSource.name}
							deviceInfo={this.state.selectedSource.deviceInfo}
							downloadToaterNotify={this.props.toasterNotifier}
							isQueueRankingLoading={this.state.isQueueRankingLoading}
							isAgentRankingLoading={this.state.isAgentRankingLoading}
						/>
					) : this.state.isConversationModalOpen ? (
						<ConversationList
							conversations={this.state.viewConversationList}
							onClose={() => {
								this.setState({
									isConversationModalOpen: false,
								});
							}}
							backBtnIcon={BackBtnIcon}
							selectedbotIcon={this.state.selectedBoticonurl}
							selectedbotName={this.state.selectedBotname}
							showLoader={this.state.showLoader}
							startDate={this.state.startDate}
							endDate={this.state.endDate}
							utcstartDate={this.getUTCData().split('::')[0]}
							utcendDate={this.getUTCData().split('::')[1]}
							selectedBotid={this.state.selectedBotid}
							botID={botID}
							selectedSource={this.state.selectedSource}
							selectedAgent={this.state.selectedAgent}
							selectedQueue={this.state.selectedQueue}
							title={this.state.cardTitle}
							// getUserdownloadAnalytics={this.getUserdownloadAnalytics}
						/>
					) : this.state.showAgentOnlineList ? (
						<RankingList
							source='RealTime'
							realTimeAgentList={this.state.realTimeAgentList}
							onClose={() => {
								this.setviewAgentList(false);
								this.fetchDetails();
								this.fetchAgentRanking();
								this.fetchQueueRanking();
							}}
							backBtnIcon={BackBtnIcon}
							setqueueRankList={this.state.queueCompleteRankList}
							selectedbotIcon={this.state.selectedBoticonurl}
							selectedbotName={this.state.selectedBotname}
							setRankingCompleteList={this.setQueueRankingCompleteList}
							startDate={this.state.startDate}
							endDate={this.state.endDate}
							utcstartDate={this.getUTCData().split('::')[0]}
							utcendDate={this.getUTCData().split('::')[1]}
							dateSelection={this.dateSelection}
							selectedFilter={this.state.selectedQueueRanking}
							botID={this.state.selectedBotid.trim() || botID}
							channelSource={this.state.selectedSource.name}
							deviceInfo={this.state.selectedSource.deviceInfo}
							downloadToaterNotify={this.props.toasterNotifier}
							isQueueRankingLoading={false}
							isAgentRankingLoading={false}
							// selectedQueue={this.state.selectedQueue}
						/>
					) : (
						<div className='analytics-data'>
							<div className='header'>
								{this.state.selectedBoticonurl !== '' &&
								this.state.selectedBotname !== '' ? (
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
										}}>
										<img
											src={this.state.selectedBoticonurl}
											alt='boticon'
											style={{
												width: '46px',
												height: '46px',
												marginLeft: '36.5px',
											}}
										/>
										<div
											style={{
												fontSize: '24px',
												marginLeft: '10px',
												fontWeight: 600,
												letterSpacing: '-0.36px',
												lineHeight: '4.33',
											}}>
											{this.state.selectedBotname}
										</div>
									</div>
								) : (
									<div style={{ marginLeft: '35px' }}>Analytics</div>
								)}
							</div>

							<div
								style={{
									margin: '0px 0px 10px 0px',
									overflowY: 'auto',
									height: 'calc(100vh - 184px)',
									overflowX: 'hidden',
									padding: '0px 36.5px 0px 0px',
								}}>
								{this.state.isdataLoading ? (
									<div
										className='showloadergif'
										style={{
											height: 'calc(100vh - 184px)',
											width: '100%',
											position: 'unset',
										}}>
										<div className='loader-analytics-inner'>
											<img
												src={LoaderGIF}
												alt='loader'
												className='loader-icon'
											/>
											<span className='loader-content'>Loading data</span>
										</div>
									</div>
								) : (
									<>
										<Realtime
											ongoingCardList={this.state.ongoingCardList}
											selectedBotid={this.state.selectedBotid}
											selectedSource={this.state.selectedSource}
											selectedAgent={this.state.selectedAgent}
											selectedQueue={this.state.selectedQueue}
											startDate={this.state.startDate}
											endDate={this.state.endDate}
											utcstartDate={this.getUTCData().split('::')[0]}
											utcendDate={this.getUTCData().split('::')[1]}
											redirectionToLoginPage={this.props.redirectionToLoginPage}
											setviewAgentList={this.setviewAgentList}
											getcurrentAgentsList={this.getcurrentAgentsList}
										/>

										<div className='date-picker-outer-w'>
											<div
												className='filter-pills'
												style={{
													display: 'flex',
													justifyContent: 'center',
													marginLeft: '30px',
													zIndex: 1,
													height: '32px',
													backgroundColor: 'white',
													borderTop: '1px solid #0000001a',
													borderBottom: 'unset',
												}}>
												<div className='date-filtering'>
													<DatePicker
														onDateSelection={(
															start: Moment,
															end: Moment,
															selected?: string
														) => {
															this.setState(
																{
																	startDate: start,
																	endDate: end,
																	isRealTimedataLoading: false,
																	selectedDate: selected,
																	// showDropdownLoader:true,
																},
																() => {
																	this.fetchDetails('newDetails');
																	this.fetchAgentRanking();
																	this.fetchQueueRanking();
																}
															);
														}}
														startDate={this.state.startDate}
														endDate={this.state.endDate}
														notificationToaster={this.props.toasterNotifier}
													/>
												</div>
											</div>
										</div>
										<div
											className='filter-bar'
											style={{ display: 'inline-block', width: '100%' }}>
											<div
												style={{
													fontSize: '20px',
													fontWeight: 600,
													marginLeft: '36.5px',
												}}>
												Overview
											</div>

											<div style={{ display: 'flex', marginLeft: '25.5px' }}>
												{/* flexWrap: 'wrap' */}
												<Dropdown
													selected={this.state.selectedQueue.name}
													options={this.queueDataList.map(
														(agent) => agent.name
													)}
													placeholder='All queues'
													onSelectionChange={this.selectQueue}
													filterType='external'
													fromAnalytics='true'
												/>
												<Dropdown
													selected={this.state.selectedAgent.name}
													options={this.state.agentList.map(
														(queue) => queue.name
													)}
													placeholder='All agents'
													onSelectionChange={this.selectAgent}
													filterType='external'
													fromAnalytics='true'
												/>
												<Dropdown
													selected={this.state.selectedSource.name}
													options={this.state.ChannelSource.map(
														(agent) => agent.name
													)}
													placeholder='All sources'
													onSelectionChange={this.selectSource}
													filterType='external'
													fromAnalytics='true'
												/>
											</div>
										</div>

										<div
											className='filter-pills'
											style={{ marginLeft: '37.5px' }}></div>
										<div className='stats-wrapper'>
											{!this.state.isdataLoading &&
												this.cardList.map((stat, index) => {
													var splitedCountVal =
														stat.count && stat.count.toString().split('_');
													return (
														<div
															key={index}
															className='stat'
															title={stat.defnitions}>
															<div className='title'>{stat.title}</div>
															<div className='count'>
																<span>
																	{splitedCountVal && splitedCountVal[0]}
																</span>
																{splitedCountVal && splitedCountVal[1] ? (
																	<span
																		style={{
																			color: 'rgba(45, 45, 45, 0.6)',
																			fontSize: '16px',
																			fontWeight: 600,
																			marginLeft: '5px',
																		}}>
																		({splitedCountVal[1]})
																	</span>
																) : (
																	<></>
																)}
															</div>
															<div
																style={{
																	display: 'flex',
																	justifyContent: 'center',
																}}>
																<div className='view'>
																	{stat.viewChats &&
																	splitedCountVal &&
																	splitedCountVal[0] !== '0' &&
																	stat.title !== 'Total Conversations' ? (
																		<div
																			className='clickable'
																			onClick={() => {
																				this.viewchats(stat.title);
																			}}
																			style={{
																				display: 'flex',
																				justifyContent: 'center',
																			}}>
																			<img src={ListIcon} alt='chat' />
																			View list
																		</div>
																	) : null}
																</div>
															</div>
														</div>
													);
												})}
										</div>
										{this.state.isdataLoading ? (
											<div
												className='agent-ranking-loader'
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													cursor: 'pointer',
													marginTop: '50px',
												}}>
												<img src={AnalyticsLoader} alt='loader' />
											</div>
										) : null}

										<div>
											<div
												style={{
													fontSize: '16px',
													fontWeight: 600,
													lineHeight: '6.5',
													letterSpacing: '-0.24px',
													color: 'rgba(0, 0, 0, 0.5)',
													marginLeft: '36.5px',
												}}>
												Handoffs by Status
											</div>
											<div
												className='stats-wrapper'
												style={{ marginTop: '-15px' }}>
												{' '}
												{!this.state.isdataLoading &&
													this.answeredHandoffs.map((stat, index) => {
														var splitedCountVal = stat.count
															.toString()
															.split('_');
														return (
															<div
																key={index}
																className='stat'
																title={stat.defnitions}>
																<div className='title'>{stat.title}</div>
																<div className='count'>
																	<span>{splitedCountVal[0]}</span>
																	{splitedCountVal[1] && (
																		<span
																			style={{
																				color: 'rgba(45, 45, 45, 0.6)',
																				fontSize: '16px',
																				fontWeight: 600,
																				marginLeft: '5px',
																			}}>
																			({splitedCountVal[1]})
																		</span>
																	)}
																</div>
																<div
																	className='view'
																	style={{ justifyContent: 'center' }}>
																	{stat.viewChats &&
																	splitedCountVal &&
																	splitedCountVal[0] !== '0' ? (
																		<div
																			className='clickable'
																			onClick={() => {
																				this.viewchats(stat.title);
																			}}
																			style={{
																				display: 'flex',
																				justifyContent: 'center',
																			}}>
																			<img src={ListIcon} alt='chat' />
																			View list
																		</div>
																	) : null}
																</div>
															</div>
														);
													})}
											</div>
										</div>
										{this.state.isdataLoading ? (
											<div
												className='agent-ranking-loader'
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													cursor: 'pointer',
													marginTop: '50px',
												}}>
												<img src={AnalyticsLoader} alt='loader' />
											</div>
										) : null}

										<div>
											<div
												style={{
													fontSize: '16px',
													fontWeight: 600,
													lineHeight: '6.5',
													letterSpacing: '-0.24px',
													color: 'rgba(0, 0, 0, 0.5)',
													marginLeft: '36.5px',
												}}>
												Performance
											</div>
											<div
												className='stats-wrapper'
												style={{ marginTop: '-15px' }}>
												{' '}
												{!this.state.isdataLoading &&
													this.performanceCardList.map((stat, index) => {
														return (
															<div
																key={index}
																className='stat'
																title={stat.defnitions}>
																<div className='title'>{stat.title}</div>
																<div className='count'>{stat.count}</div>
															</div>
														);
													})}
											</div>
										</div>
										{this.state.isdataLoading ? (
											<div
												className='agent-ranking-loader'
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													cursor: 'pointer',
													marginTop: '50px',
												}}>
												<img src={AnalyticsLoader} alt='loader' />
											</div>
										) : null}

										<div
											style={{
												display: 'flex',
												justifyContent: 'space-between',
												margin: '51px 0px 0px 36.5px',
												borderBottom: '1px solid #0000001a',
											}}
											className='filter-bar'>
											<div style={{ fontSize: '20px', fontWeight: 600 }}>
												Agent rankings
											</div>
											<div style={{ display: 'flex' }}>
												<div
													style={{
														fontSize: '14px',
														display: 'flex',
														alignItems: 'center',
														fontWeight: 'normal',
														letterSpacing: '-0.21px',
													}}>
													Rank By:
												</div>
												<Dropdown
													selected={this.state.selectedAgentRanking.name}
													options={this.state.agentRankingList.map(
														(agentRank) => agentRank.name
													)}
													placeholder='Select agent ranking'
													onSelectionChange={this.selectAgentRanking}
													filterType='external'
													fromAnalytics='true'
												/>
											</div>
										</div>
										{this.state.rankings.topAgents.length > 0 &&
										!this.state.isAgentRankingLoading ? (
											// && !this.state.isdataLoading
											<div
												className='rankings'
												style={{ marginLeft: '36.5px' }}>
												{this.state.rankings.topAgents.length > 0 && (
													<div className='ranking'>
														<div className='rank-title'>Top Ranked Agents</div>
														<div className='rank-card'>
															<div className='rank-card-header'>
																<div
																	style={{
																		width: '25%',
																		display: 'flex',
																		justifyContent: 'flex-start',
																	}}>
																	Rank
																</div>
																<div
																	style={{
																		width: '50%',
																		display: 'flex',
																		justifyContent: 'flex-start',
																	}}>
																	Agents
																</div>
																<div
																	style={{
																		width: '50%',
																		display: 'flex',
																		justifyContent: 'flex-start',
																	}}>
																	{this.state.selectedAgentRanking.name ===
																	'User Feedback'
																		? 'User Feedback (Positive)'
																		: this.state.selectedAgentRanking.name ===
																		  'Overall Performance'
																		? 'Score'
																		: this.state.selectedAgentRanking.name}
																</div>
															</div>
															<div className='rank-card-content'>
																{this.state.rankings.topAgents.map(
																	(agent, index) => {
																		var averageAgentResponseTime = '';
																		if (
																			this.state.selectedAgentRanking.name ===
																			'Avg. Agent Response Time'
																		) {
																			agent.chatHandled === 0
																				? (averageAgentResponseTime = '-')
																				: (averageAgentResponseTime =
																						this.convertSecondstoTime(
																							agent.chatHandled
																						));
																		}

																		return (
																			<div
																				key={index}
																				className='row'
																				style={{ display: 'flex' }}
																				onClick={() => {
																					this.viewchats('', agent.agentId);
																				}}>
																				<div
																					style={{
																						width: '25%',
																						display: 'flex',
																						justifyContent: 'flex-start',
																					}}>
																					{this.state.selectedAgentRanking
																						.name === 'Avg. Agent Response Time'
																						? averageAgentResponseTime === '-'
																							? '-'
																							: index + 1
																						: agent.rank === -1
																						? '-'
																						: agent.rank}
																				</div>
																				<div
																					style={{
																						width: '50%',
																						display: 'flex',
																						justifyContent: 'flex-start',
																					}}>
																					{agent.name}
																				</div>
																				{this.state.selectedAgentRanking
																					.name !==
																					'Avg. Agent Response Time' &&
																				this.state.selectedAgentRanking.name !==
																					'User Feedback' &&
																				this.state.selectedAgentRanking.name !==
																					'Overall Performance' &&
																				this.state.selectedAgentRanking.name !==
																					'Answered Handoffs' ? (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{agent.count === -100 &&
																						agent.percentage === -100 ? (
																							'-'
																						) : (
																							<>
																								{agent.count + '%'}
																								<span
																									style={{ marginLeft: '5px' }}>
																									{' '}
																									(
																									{agent.percentage &&
																										agent.percentage}
																									)
																								</span>
																							</>
																						)}
																					</div>
																				) : this.state.selectedAgentRanking
																						.name === 'User Feedback' ? (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{agent.count === -100
																							? '-'
																							: agent.count + '%'}
																					</div>
																				) : this.state.selectedAgentRanking
																						.name === 'Answered Handoffs' ? (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{agent.percentage === -100
																							? '-'
																							: agent.percentage}
																					</div>
																				) : this.state.selectedAgentRanking
																						.name ===
																				  'Avg. Agent Response Time' ? (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{averageAgentResponseTime &&
																							averageAgentResponseTime}
																					</div>
																				) : (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{this.state.selectedAgentRanking
																							.name === 'Overall Performance'
																							? agent.count === -100
																								? '-'
																								: agent.count
																							: agent.count}
																					</div>
																				)}
																			</div>
																		);
																	}
																)}
															</div>
														</div>
													</div>
												)}

												{this.state.shwLowRankedAgentData &&
													this.lowAgentData.length > 0 &&
													!this.state.isAgentRankingLoading && (
														// !this.state.isdataLoading &&
														<div className='ranking'>
															<div className='rank-title'>
																Lowest Ranked Agents
															</div>
															<div className='rank-card'>
																<div className='rank-card-header'>
																	<div
																		style={{
																			width: '25%',
																			display: 'flex',
																			justifyContent: 'flex-start',
																		}}>
																		Rank
																	</div>
																	<div
																		style={{
																			width: '50%',
																			display: 'flex',
																			justifyContent: 'flex-start',
																		}}>
																		Agents
																	</div>
																	<div
																		style={{
																			width: '50%',
																			display: 'flex',
																			justifyContent: 'flex-start',
																		}}>
																		{this.state.selectedAgentRanking.name ===
																		'User Feedback'
																			? 'User Feedback (Positive)'
																			: this.state.selectedAgentRanking.name ===
																			  'Overall Performance'
																			? 'Score'
																			: this.state.selectedAgentRanking.name}
																	</div>
																</div>
																<div className='rank-card-content'>
																	{this.lowAgentData.map((agent, index) => {
																		var averageAgentResponseTime = '';
																		if (
																			this.state.selectedAgentRanking.name ===
																			'Avg. Agent Response Time'
																		) {
																			agent.count === 0
																				? (averageAgentResponseTime = '-')
																				: (averageAgentResponseTime =
																						this.convertSecondstoTime(
																							agent.count
																						));
																		}
																		return (
																			<div
																				key={index}
																				className='row'
																				style={{ display: 'flex' }}
																				onClick={() => {
																					this.viewchats('', agent.agentId);
																				}}>
																				<div
																					style={{
																						width: '25%',
																						display: 'flex',
																						justifyContent: 'flex-start',
																					}}>
																					{this.state.selectedAgentRanking
																						.name === 'Avg. Agent Response Time'
																						? averageAgentResponseTime === '-'
																							? '-'
																							: index + 1
																						: agent.rank === -1
																						? '-'
																						: agent.rank}
																				</div>
																				<div
																					style={{
																						width: '50%',
																						display: 'flex',
																						justifyContent: 'flex-start',
																					}}>
																					{agent.name}
																				</div>
																				{this.state.selectedAgentRanking
																					.name !==
																					'Avg. Agent Response Time' &&
																				this.state.selectedAgentRanking.name !==
																					'User Feedback' &&
																				this.state.selectedAgentRanking.name !==
																					'Overall Performance' &&
																				this.state.selectedAgentRanking.name !==
																					'Answered Handoffs' ? (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{agent.count === -100 &&
																						agent.percentage === -100 ? (
																							'-'
																						) : (
																							<>
																								{agent.count + '%'}
																								<span
																									style={{ marginLeft: '5px' }}>
																									{' '}
																									(
																									{agent.percentage &&
																										agent.percentage}
																									)
																								</span>
																							</>
																						)}
																					</div>
																				) : this.state.selectedAgentRanking
																						.name === 'User Feedback' ? (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{agent.count === -100
																							? '-'
																							: agent.count + '%'}
																					</div>
																				) : this.state.selectedAgentRanking
																						.name === 'Answered Handoffs' ? (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{agent.percentage === -100
																							? '-'
																							: agent.percentage}
																					</div>
																				) : this.state.selectedAgentRanking
																						.name ===
																				  'Avg. Agent Response Time' ? (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{averageAgentResponseTime &&
																							averageAgentResponseTime}
																					</div>
																				) : (
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{this.state.selectedAgentRanking
																							.name === 'Overall Performance'
																							? agent.count === -100
																								? '-'
																								: agent.count
																							: agent.count}
																					</div>
																				)}
																			</div>
																		);
																	})}
																</div>
															</div>
														</div>
													)}
											</div>
										) : (
											<div
												style={
													!this.state.isAgentRankingLoading
														? // && !this.state.isdataLoading
														  {
																fontSize: '14px',
																lineHeight: '1.29',
																color: 'rgba(0,0,0,0.4)',
																display: 'flex',
																justifyContent: 'center',
																marginTop: '50px',
														  }
														: { display: 'none' }
												}>
												No data to display
											</div>
										)}
										{this.state.agentList.length > 0 &&
											!this.state.isAgentRankingLoading && (
												// && !this.state.isdataLoading
												<div
													style={{
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														cursor: 'pointer',
														marginTop: '27px',
													}}
													onClick={this.agentRankingCompleteList.bind(this)}>
													<img src={ListIcon} alt='agent list' />
													<div style={{ marginLeft: '6px', color: '#6c7ef2' }}>
														View complete list
													</div>
												</div>
											)}
										{this.state.isAgentRankingLoading ? (
											// || this.state.isdataLoading
											<div
												className='agent-ranking-loader'
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													cursor: 'pointer',
													marginTop: '50px',
												}}>
												<img src={AnalyticsLoader} alt='loader' />
											</div>
										) : null}
										<div
											style={{
												display: 'flex',
												justifyContent: 'space-between',
												margin: '51px 0px 0px 36.5px',
												borderBottom: '1px solid #0000001a',
											}}
											className='filter-bar'>
											<div style={{ fontSize: '20px', fontWeight: 600 }}>
												Queue rankings
											</div>
											<div style={{ display: 'flex' }}>
												<div
													style={{
														fontSize: '14px',
														display: 'flex',
														alignItems: 'center',
														fontWeight: 'normal',
														letterSpacing: '-0.21px',
													}}>
													Rank By:
												</div>
												<Dropdown
													selected={this.state.selectedQueueRanking.name}
													options={this.state.queueRankingList.map(
														(queueRank) => queueRank.name
													)}
													placeholder='Select queue ranking'
													onSelectionChange={this.selectQueueRanking}
													filterType='external'
													fromAnalytics='true'
												/>
											</div>
										</div>
										{this.state.rankings.topQueue.length > 0 &&
										!this.state.isQueueRankingLoading ? (
											//  && !this.state.isdataLoading
											<div
												className='rankings'
												style={{ marginLeft: '36.5px' }}>
												{this.state.rankings.topQueue.length > 0 && (
													<div className='ranking'>
														<div className='rank-title'>Top Ranked Queue</div>
														<div className='rank-card'>
															<div className='rank-card-header'>
																<div
																	style={{
																		width: '25%',
																		display: 'flex',
																		justifyContent: 'flex-start',
																	}}>
																	Rank
																</div>
																<div
																	style={{
																		width: '50%',
																		display: 'flex',
																		justifyContent: 'flex-start',
																	}}>
																	Queues
																</div>
																<div
																	style={{
																		width: '50%',
																		display: 'flex',
																		justifyContent: 'flex-start',
																	}}>
																	{this.state.selectedQueueRanking.name ===
																	'User Feedback'
																		? 'User Feedback (Positive)'
																		: this.state.selectedQueueRanking.name ===
																		  'Overall Performance'
																		? 'Score'
																		: this.state.selectedQueueRanking.name}
																</div>
															</div>
															<div className='rank-card-content'>
																{this.state.rankings.topQueue &&
																	this.state.rankings.topQueue.map(
																		(queue, index) => {
																			var averageUserWaitTimeinQueue = '';
																			if (
																				this.state.selectedQueueRanking.name ===
																				'Avg. User Wait Time in Queue'
																			) {
																				queue.count === 0
																					? (averageUserWaitTimeinQueue = '-')
																					: (averageUserWaitTimeinQueue =
																							this.convertSecondstoTime(
																								queue.count
																							));
																			}

																			return (
																				<div
																					key={index}
																					className='row'
																					style={{ display: 'flex' }}
																					onClick={() => {
																						this.viewchats(
																							'',
																							'',
																							queue.agentId
																						);
																					}}>
																					<div
																						style={{
																							width: '25%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{this.state.selectedQueueRanking
																							.name ===
																							'Avg. User Wait Time in Queue' ||
																						this.state.selectedQueueRanking
																							.name === 'No. of Handoffs'
																							? queue.count === -100
																								? '-'
																								: index + 1
																							: queue.rank === -1
																							? '-'
																							: queue.rank}
																					</div>
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{queue.name}
																					</div>
																					{this.state.selectedQueueRanking
																						.name !== 'No. of Handoffs' &&
																					this.state.selectedQueueRanking
																						.name !==
																						'Avg. User Wait Time in Queue' &&
																					this.state.selectedQueueRanking
																						.name !== 'User Feedback' &&
																					this.state.selectedQueueRanking
																						.name !== 'Overall Performance' &&
																					this.state.selectedQueueRanking
																						.name !== 'Answered Handoffs' ? (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{queue.count === -100 &&
																							queue.percentage === -100 ? (
																								'-'
																							) : (
																								<>
																									{queue.count + '%'}
																									<span
																										style={{
																											marginLeft: '5px',
																										}}>
																										{' '}
																										(
																										{queue.percentage &&
																											queue.percentage}
																										)
																									</span>
																								</>
																							)}
																						</div>
																					) : this.state.selectedQueueRanking
																							.name ===
																					  'Avg. User Wait Time in Queue' ? (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{averageUserWaitTimeinQueue &&
																								averageUserWaitTimeinQueue}
																						</div>
																					) : this.state.selectedQueueRanking
																							.name === 'User Feedback' ? (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{queue.count === -100
																								? '-'
																								: queue.count + '%'}
																						</div>
																					) : this.state.selectedQueueRanking
																							.name === 'Answered Handoffs' ? (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{queue.count === -100 &&
																							queue.percentage === -100 ? (
																								'-'
																							) : (
																								<>
																									{queue.count + '%'}
																									<span
																										style={{
																											marginLeft: '5px',
																										}}>
																										{' '}
																										(
																										{queue.percentage &&
																											queue.percentage}
																										)
																									</span>
																								</>
																							)}
																						</div>
																					) : (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{this.state.selectedQueueRanking
																								.name === 'Overall Performance'
																								? queue.count === -100
																									? '-'
																									: queue.count
																								: queue.count}
																						</div>
																					)}
																				</div>
																			);
																		}
																	)}
															</div>
														</div>
													</div>
												)}

												{this.state.shwLowRankedQueueData &&
													this.lowQueueData.length > 0 &&
													!this.state.isQueueRankingLoading && (
														// !this.state.isdataLoading &&
														<div className='ranking'>
															<div className='rank-title'>
																Lowest Ranked Queue
															</div>
															<div className='rank-card'>
																<div className='rank-card-header'>
																	<div
																		style={{
																			width: '25%',
																			display: 'flex',
																			justifyContent: 'flex-start',
																		}}>
																		Rank
																	</div>
																	<div
																		style={{
																			width: '50%',
																			display: 'flex',
																			justifyContent: 'flex-start',
																		}}>
																		Queues
																	</div>
																	<div
																		style={{
																			width: '50%',
																			display: 'flex',
																			justifyContent: 'flex-start',
																		}}>
																		{this.state.selectedQueueRanking.name ===
																		'User Feedback'
																			? 'User Feedback (Positive)'
																			: this.state.selectedQueueRanking.name ===
																			  'Overall Performance'
																			? 'Score'
																			: this.state.selectedQueueRanking.name}
																	</div>
																</div>
																<div className='rank-card-content'>
																	{this.lowQueueData &&
																		this.lowQueueData.map((queue, index) => {
																			var averageUserWaitTimeinQueue = '';
																			if (
																				this.state.selectedQueueRanking.name ===
																				'Avg. User Wait Time in Queue'
																			) {
																				queue.count === 0
																					? (averageUserWaitTimeinQueue = '-')
																					: (averageUserWaitTimeinQueue =
																							this.convertSecondstoTime(
																								queue.count
																							));
																			}
																			return (
																				<div
																					key={index}
																					className='row'
																					style={{ display: 'flex' }}
																					onClick={() => {
																						this.viewchats(
																							'',
																							'',
																							queue.agentId
																						);
																					}}>
																					<div
																						style={{
																							width: '25%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{this.state.selectedQueueRanking
																							.name ===
																							'Avg. User Wait Time in Queue' ||
																						this.state.selectedQueueRanking
																							.name === 'No. of Handoffs'
																							? queue.count === -100
																								? '-'
																								: index + 1
																							: queue.rank === -1
																							? '-'
																							: queue.rank}
																					</div>
																					<div
																						style={{
																							width: '50%',
																							display: 'flex',
																							justifyContent: 'flex-start',
																						}}>
																						{queue.name}
																					</div>
																					{this.state.selectedQueueRanking
																						.name !== 'No. of Handoffs' &&
																					this.state.selectedQueueRanking
																						.name !==
																						'Avg. User Wait Time in Queue' &&
																					this.state.selectedQueueRanking
																						.name !== 'User Feedback' &&
																					this.state.selectedQueueRanking
																						.name !== 'Overall Performance' ? (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{queue.count === -100 &&
																							queue.percentage === -100 ? (
																								'-'
																							) : (
																								<>
																									{queue.count + '%'}
																									<span
																										style={{
																											marginLeft: '5px',
																										}}>
																										{' '}
																										(
																										{queue.percentage &&
																											queue.percentage}
																										)
																									</span>
																								</>
																							)}
																						</div>
																					) : this.state.selectedQueueRanking
																							.name ===
																					  'Avg. User Wait Time in Queue' ? (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{averageUserWaitTimeinQueue &&
																								averageUserWaitTimeinQueue}
																						</div>
																					) : this.state.selectedQueueRanking
																							.name === 'User Feedback' ? (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{queue.count === -100
																								? '-'
																								: queue.count + '%'}
																						</div>
																					) : (
																						<div
																							style={{
																								width: '50%',
																								display: 'flex',
																								justifyContent: 'flex-start',
																							}}>
																							{this.state.selectedQueueRanking
																								.name === 'Overall Performance'
																								? queue.count === -100
																									? '-'
																									: queue.count
																								: queue.count}
																						</div>
																					)}
																				</div>
																			);
																		})}
																</div>
															</div>
														</div>
													)}
											</div>
										) : (
											<div
												style={
													!this.state.isQueueRankingLoading
														? //  && !this.state.isdataLoading
														  {
																fontSize: '14px',
																lineHeight: '1.29',
																color: 'rgba(0,0,0,0.4)',
																display: 'flex',
																justifyContent: 'center',
																marginTop: '50px',
																paddingBottom: '20px',
														  }
														: { display: 'none' }
												}>
												No data to display
											</div>
										)}
										{this.state.queueFilter.length > 0 &&
											!this.state.isQueueRankingLoading && (
												// !this.state.isdataLoading &&
												<div
													style={{
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														cursor: 'pointer',
														marginBottom: '10px',
														marginTop: '27px',
													}}
													onClick={this.queueRankingCompleteList.bind(this)}>
													<img src={ListIcon} alt='queue list' />
													<div style={{ marginLeft: '6px', color: '#6c7ef2' }}>
														View complete list
													</div>
												</div>
											)}
										{this.state.isQueueRankingLoading ? (
											//  || this.state.isdataLoading
											<div
												className='agent-ranking-loader'
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													cursor: 'pointer',
													marginTop: '50px',
												}}>
												<img src={AnalyticsLoader} alt='loader' />
											</div>
										) : null}

										<Modal
											isOpen={this.state.isConevrsationTimelineOpen}
											title='Total Conversations'
											onClose={() => {
												this.setState({
													isConevrsationTimelineOpen: false,
												});
											}}>
											<TimeLineConversationList />
										</Modal>
									</>
								)}
							</div>
						</div>
					)}
				</div>
			);
		} else {
			return <></>;
		}
	}
}
